export default "__VITE_ASSET__Dj1GAAiU__"